export default function getThresholds(anglesConfig) {
  return {
    back: [anglesConfig?.backGreen, anglesConfig?.backYellow],
    neck: [anglesConfig?.neckGreen, anglesConfig?.neckYellow],
    hand: [anglesConfig?.handGreen, anglesConfig?.handYellow],
    leg: [anglesConfig?.legGreen, anglesConfig?.legYellow],
    reba: [1, 4, 8, 11],
  };
}
